/* カート画面ラッピング処理
  Liquid側で出力されたラッピング商品追加用UIに対する各機能の実装
*/

/*=== ラッピングUIに対する関数 ========================*/
// ラッピングUIの初期表示
function cartWrapping(wrappingTargetItemsUI) {
  console.log('test')
  // ラッピング対象行ごとに処理
  wrappingTargetItemsUI?.forEach(function(targetItem) {
    wrappingStateCheck(targetItem);
    wrappingDetailToggle(targetItem);
  })
}

// ユーザー操作によるラッピングUIの表示切り替えtoggle
function wrappingDetailToggle(wrappingUIRow) {
  // 変数宣言
  const wrappingUIHeader = wrappingUIRow.querySelector(".cart-wrapping__header"),
        wrappingSectionHeader = wrappingUIRow.querySelectorAll(".cart-wrapping__items--header"),
        messageCardSelectBtn = wrappingUIRow.querySelector(".messsageToggleBtn"),
        messageCardInputSection = wrappingUIRow.querySelector(".wrapping-message");

  // ラッピングUIのtoggle
  // wrappingUIHeader?.addEventListener('click', function(){
  //   wrappingUIRow.classList.toggle("is-show");
  // });

  // ラッピング選択欄のtoggle
  wrappingSectionHeader?.forEach(function(header) {
    // 既にイベントリスナーが設定されているかをチェック
    if (!header.dataset.clickListenerSet) {
      header.dataset.clickListenerSet = 'true'; // フラグを設定

      header.addEventListener('click', function() {
        header.closest(".cart-wrapping__section").classList.toggle("is-hidden");
      });
    }
  });

  // メッセージカード入力欄のtoggle
  messageCardSelectBtn?.addEventListener('click', function(){
    messageCardInputSection?.classList.toggle("visually-hidden");
  });
}

// カート内のラッピング追加済み商品判定と折り畳み処理
function wrappingStateCheck(wrappingUIRow) {
  const wrappingLineItems = document.querySelectorAll(".cart-item:not(.ajax-cart__item--remove) .cart-item__property"),
        wrappingUISection = wrappingUIRow.querySelectorAll(".cart-wrapping__section"),
        wrappingTargetName = wrappingUIRow.getAttribute("data-taget-product-name");
  let lineitemTitle = "",
      wrappingProductName = "";

  // 初期表示の折りたたみリセット
  wrappingUISection?.forEach(function(section) {
    section.classList.remove("is-hidden");
  });

  // カート内のラッピング商品ごとに判定を実行
  wrappingLineItems?.forEach(function(lineitem) {
    // 文言「商品指定」がlineitemに含まれているかチェック
    if(lineitem.textContent.includes("商品指定")) {
      // lineitem.textContentの「商品指定」以降の文字列を取得
      lineitemTitle = lineitem.textContent.split("商品指定:")[1];
      // lineitemの親要素からラッピング商品名を取得
      wrappingProductName = lineitem.closest("td").querySelector(".cart-item__meta-title").textContent;
    }

    // ラッピング対象商品のラッピングUIを折り畳む
    if(lineitemTitle.includes(wrappingTargetName) && wrappingProductName.includes("メッセージ")) {
      wrappingUIRow.classList.add("is-show");
      wrappingUIRow.querySelector(".cart-wrapping__section--card").classList.add("is-hidden");
    } else if(lineitemTitle.includes(wrappingTargetName)) {
      wrappingUIRow.classList.add("is-show");
      wrappingUIRow.querySelector(".cart-wrapping__section--box").classList.add("is-hidden");
    }
  })
}

// ラッピング商品とカート内商品の数量一致判定、および小計算出
function wrappingQuantityUpdate() {
  let wrappingProductItems = document.querySelectorAll("[data-wrapping-info='wrapping_product']"),
      wrappingCardItems = document.querySelectorAll("[data-wrapping-info='wrapping_card']"),
      wrappingTargetItems = document.querySelectorAll("[data-wrapping-info='target_product']");
      const announcement = document.querySelector(".cart-wrapping__announcement");

  // 変数情報を元に、カート内の商品情報と付き合わせる
  // ラッピング商品・ラッピング対象商品のカート内数量を合算取得
  function itemSumQuantityReturn(targetItems){
    let itemSumQuantity = 0;
    targetItems?.forEach(function(targetItem) {
      const targetItemId = targetItem.getAttribute("data-cart-item-target-id"),
      targetItemInCart = document.querySelector(`[data-cart-item-id="${targetItemId}"]`);

      itemSumQuantity = itemSumQuantity + Number(targetItemInCart?.querySelector(".cart-item__qty-input").value);
    });
    return itemSumQuantity;
  }
  //　数量の個別取得にはこちらを使う
  function itemQuantityReturn(targetItem){
    let itemQuantity = 0;
    const targetItemId = targetItem.getAttribute("data-cart-item-target-id"),
      targetItemInCart = document.querySelector(`[data-cart-item-id="${targetItemId}"]`);

    if(targetItemInCart === null) return itemQuantity;
    itemQuantity = Number(targetItemInCart?.querySelector(".cart-item__qty-input").value);

    return itemQuantity;
  }

  function wrappingSubtotalUpdate() {

    let cartWrappingSubtotal = 0;
    const cartWrappingSubtotalUI = document.querySelector("#cartWrappingSubtotal"),
          cartProductSubtotalUI = document.querySelector("#cartProductSubtotal"),
          cartSubtotalUI = document.querySelector("#cartSubTotal .cart-subtotal__price");

    // ラッピング商品の小計を取得
    function wrappingProductSubtotalReturn(wrappingItems) {
      let wrappingSubtotal = 0;
      wrappingItems?.forEach(function(wrappingItem) {
        // wrappingProductItemのdata-priceを取得
        const wrappingItemPrice = Number(wrappingItem.getAttribute("data-price"));
        // 対象商品群の数量を取得
        const wrappingItemQuantity = itemQuantityReturn(wrappingItem);
        // 小計を計算
        const wrappingItemSubtotal = wrappingItemPrice * wrappingItemQuantity;
        wrappingSubtotal = wrappingSubtotal + wrappingItemSubtotal;
      });
      return wrappingSubtotal;
    }

    cartWrappingSubtotal = wrappingProductSubtotalReturn(wrappingProductItems) + wrappingProductSubtotalReturn(wrappingCardItems);

    cartWrappingSubtotalUI.textContent = "¥" + cartWrappingSubtotal.toLocaleString();

    // 動的更新後の小計価格を取得し、ラッピング以外の小計も算出する
    const cartSubtotal = Number(cartSubtotalUI.textContent.replace(/[^0-9]/g, ''));

    cartProductSubtotalUI.textContent = "¥" + (cartSubtotal - cartWrappingSubtotal).toLocaleString();

  }


  // ラッピング商品数量と対象商品数量の一致判定
  // ラッピング商品が一点以上あれば実行する
  if(wrappingProductItems.length > 0) {

    // 両者の数量が一致しない場合、メッセージを表示する
    if(itemSumQuantityReturn(wrappingTargetItems) !== itemSumQuantityReturn(wrappingProductItems)) {
      announcement.classList.remove("is-hidden");
    } else {
      announcement.classList.add("is-hidden");
    }
  } else {
    announcement.classList.add("is-hidden");
  }

  // ラッピング関連商品の小計アップデート
  // ラッピング商品かラッピングカードが一点以上存在する場合に実行する
  if(wrappingProductItems.length > 0 || wrappingCardItems.length > 0) {
    wrappingSubtotalUpdate();
  }

}

// カート内商品が削除された際のラッピングUIの更新
// ※theme.jsのカート削除関数内からコールする
function wrappingDeletedUpdate(deletedItem) {

  // 削除されたtr要素のdata-cart-item-id値を元に情報を付き合わせる
  const deletedItemKey = deletedItem[0].getAttribute("data-cart-item-id"),
        deletedItemInfo = document.querySelector(`[data-cart-item-target-id="${deletedItemKey}"]`),
        deletedItemName = deletedItemInfo?.getAttribute("data-wrapping-target-name"),
        wrappingTargetItems = document.querySelectorAll(".cart-wrapping__item");

  wrappingTargetItems?.forEach(function(targetItem) {
    const targetItemName = targetItem.getAttribute("data-taget-product-name");
    // 削除された商品とラッピングUIの商品名称が一致する場合は非表示に
    if(targetItemName === deletedItemName) {
      targetItem.classList.add("is-hidden");
    }
  })

  let wrappingTargetItemsUI = document.querySelectorAll(".cart-wrapping__item");
  cartWrapping(wrappingTargetItemsUI);
}

/*=== 小計まわりの関数定義 ================================*/
// 複製された小計のアップデート
function clonedSubtotalUpdate(subtotalText) {
  const clonedSubtotal = document.querySelector(".cart-subtotal--clone"),
        clonedSubtotalText = clonedSubtotal?.querySelector(".cart-subtotal__price--clone");
    clonedSubtotalText.textContent = subtotalText.textContent;
}

// 小計の更新監視と関数コール（商品の数量変更、削除時に実行される）
function subtotalMutationObserver(subtotal) {

  const subtotalText = subtotal?.querySelector(".cart-subtotal__price");

  const subtotalObserver = new MutationObserver(function(mutations) {
    clonedSubtotalUpdate(subtotalText);
    wrappingQuantityUpdate();
  });

  subtotalObserver.observe(subtotal, {childList: true, subtree: true, characterData: true});
}

// メッセージカードの文字数カウント
function messageCardCount(){
  const messagecard = document.querySelectorAll('.wrapping-message');
  messagecard.forEach(function(card){
    const message = card.querySelector('.wrapping-message__input');
    message.addEventListener('input', function(){
      const button = card.querySelector('button');
      const cartButton = document.querySelector('button[name="checkout"]');
      const messageAnnouncement = document.querySelector('.cart-wrapping__card-announcement');
      if(message.value.length == 0 || message.value.length > 200){
        button.disabled = true;
        message.classList.add('is-error');
        cartButton.disabled = false;
        messageAnnouncement.classList.add('is-hidden');
      }else{
        button.disabled = false;
        message.classList.remove('is-error');
        messageAnnouncement.classList.remove('is-hidden');
        cartButton.disabled = true;
      }
    });

  });

}

/*=== 日時指定のアイコン変更
================================*/
function changeDeliverIcons(){
  // 対象となるノードを取得
  const targetNode = document.querySelector('body');

  if(document.querySelector('#cc-select-days-opt')){
    changeIcon();
  }else{

    // オプションを設定（属性変化を監視）
    const config = {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['class']
    };

    // コールバック関数を作成
    const callback = function(mutationsList, observer) {
      for(let mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (mutation.target.classList.contains('cc-cal-icon')) {
            changeIcon();
          }
        }
      }
    };

    // MutationObserver を作成
    const observer = new MutationObserver(callback);

    // 監視を開始
    observer.observe(targetNode, config);
    observer.disconnect();
  }
}

function changeIcon(){
  if(document.querySelector('#cc-select-days')){
    document.querySelector('#cc-select-days .cc-cal-icon').innerHTML = `<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 8C15 8 11.3175 13 10 13C8.6825 13 5 8 5 8" stroke="#151D25" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
  }
  if(document.querySelector('#cc-calendar-input')){
    document.querySelector('#cc-calendar-input .cc-cal-icon').innerHTML = `<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 2.1665V3.83317M5 2.1665V3.83317M8.33333 14.6665V11.6223C8.33333 11.4632 8.21917 11.3332 8.07917 11.3332H7.5M11.3583 14.6665L12.4867 11.6248C12.5392 11.4823 12.4275 11.3332 12.2675 11.3332H10.8333" stroke="#151D25" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.00004 7.16667H15M2.08337 10.7025C2.08337 7.07167 2.08337 5.25583 3.12671 4.1275C4.17004 3 5.85004 3 9.20837 3H10.7917C14.15 3 15.83 3 16.8734 4.12833C17.9167 5.25583 17.9167 7.07167 17.9167 10.7033V11.1308C17.9167 14.7617 17.9167 16.5775 16.8734 17.7058C15.83 18.8333 14.15 18.8333 10.7917 18.8333H9.20837C5.85004 18.8333 4.17004 18.8333 3.12671 17.705C2.08337 16.5775 2.08337 14.7617 2.08337 11.13V10.7025Z" stroke="#151D25" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
  }
  if(document.querySelector('#cc-selection')){
    document.querySelector('#cc-selection .cc-cal-icon').innerHTML = `<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.99996 18.8332C14.6023 18.8332 18.3333 15.1022 18.3333 10.4998C18.3333 5.89746 14.6023 2.1665 9.99996 2.1665C5.39759 2.1665 1.66663 5.89746 1.66663 10.4998C1.66663 15.1022 5.39759 18.8332 9.99996 18.8332Z" stroke="#151D25" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M10 7.1665V10.4998L11.6667 12.1665" stroke="#151D25" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

  }
}




/*=== 実行 ============================================*/
// ページ読み込み時に実行（ラッピンググッズのカート追加時も再度実行される）
window.addEventListener('load',function(){

  // ラッピングの処理
  const wrappingUI = document.querySelector("#cartWrappingConteiner")
  if(wrappingUI) {

    // 変数定義
    const wrappingTargetItemsUI = document.querySelectorAll(".cart-wrapping__item");

    const wrappingFunctions = new Promise((resolve) => {
      cartWrapping(wrappingTargetItemsUI);
      resolve();
    })
    // ラッピングUIの処理後、数量判定とラッピング小計の取得を実行
    wrappingFunctions.then(() => {
      wrappingQuantityUpdate();
    }).catch((error) => {
      console.log(error);
    })
    messageCardCount();
  }

  // 小計の動的監視
  const subtotal = document.querySelector("#cartSubTotal");
  if(subtotal) {
    subtotalMutationObserver(subtotal);
  }

  // 日時指定のアイコン変更
  changeDeliverIcons();
});
